export const SECTORS = [
  {
    slug: "corporate-offices",
    name: "Corporate Offices & High-Rises",
    icon: "Building2",
    desc: "Custom janitorial schedules tailored to active corporate workflows.",
    body: [
      "First impressions happen in the lobby, and productivity happens at clean desks. We build office cleaning programs around your operating hours — nightly crews, day porters, and weekend deep work — so your team never sees the mess or the mop.",
      "From single-suite firms to multi-floor corporate tenants, Tbay Cleaning Services delivers supervised, quality-audited office cleaning across Canada with one point of contact and one transparent invoice.",
    ],
    services: ["commercial-cleaning", "janitorial-services", "carpet-cleaning", "window-cleaning"],
  },
  {
    slug: "healthcare-dental-clinics",
    name: "Healthcare & Dental Clinics",
    icon: "Cross",
    desc: "Clinical-grade disinfection protocols for patient environments.",
    body: [
      "Medical environments demand more than a clean appearance — they demand verified hygiene. Our healthcare cleaning teams follow clinical-grade disinfection protocols, colour-coded cross-contamination controls, and detailed cleaning logs.",
      "We service dental offices, walk-in clinics, physio and wellness centres, and medical labs with staff trained for sensitive patient environments.",
    ],
    services: ["commercial-cleaning", "janitorial-services", "deep-cleaning", "eco-friendly-cleaning"],
  },
  {
    slug: "educational-facilities",
    name: "Schools & Educational Campuses",
    icon: "GraduationCap",
    desc: "Safe, eco-friendly cleaning for nurseries, schools, and campuses.",
    body: [
      "Children and students need clean spaces that are also safe spaces. Our education-sector programs use non-toxic products, after-hours scheduling, and high-touch disinfection routines designed for classrooms, gyms, and cafeterias.",
      "From daycares to university buildings, we scale crews for September startups, summer deep cleans, and daily in-year maintenance.",
    ],
    services: ["janitorial-services", "eco-friendly-cleaning", "deep-cleaning", "pressure-washing"],
  },
  {
    slug: "retail-shopping-centres",
    name: "Retail Stores & Shopping Centres",
    icon: "ShoppingBag",
    desc: "High-visibility floor shine and entrance glass maintenance.",
    body: [
      "Retail cleanliness is merchandising. Gleaming floors, spotless fitting rooms, and streak-free entrance glass directly influence how customers rate your store — and how long they stay.",
      "We deliver pre-open crews, day porters for peak traffic, and overnight floor-care programs for retail environments of every size.",
    ],
    services: ["commercial-cleaning", "janitorial-services", "window-cleaning", "pressure-washing"],
  },
  {
    slug: "industrial-logistics",
    name: "Industrial & Logistics Facilities",
    icon: "Warehouse",
    desc: "Heavy-duty floor scrubbing and safe industrial-area care.",
    body: [
      "Warehouses and industrial facilities need cleaning that respects safety programs and operational uptime. Our industrial teams handle high-bay dusting, machine-adjacent cleaning, floor scrubbing, and staff amenity areas.",
      "We coordinate around shifts and shipping schedules, with crews trained for industrial environments and WHMIS-aware practices.",
    ],
    services: ["janitorial-services", "commercial-cleaning", "pressure-washing", "deep-cleaning"],
  },
  {
    slug: "financial-institutions",
    name: "Financial Institutions & Banks",
    icon: "ShieldCheck",
    desc: "Security-cleared janitorial personnel for sensitive branches.",
    body: [
      "Banks and financial offices require cleaners who clear security protocols without friction. Our personnel are background-checked, uniformed, and trained for restricted environments with alarm and access procedures.",
      "Branch programs cover public areas, offices, ATM vestibules, and glass — delivered discreetly outside business hours.",
    ],
    services: ["janitorial-services", "commercial-cleaning", "window-cleaning", "carpet-cleaning"],
  },
  {
    slug: "hospitality-restaurants",
    name: "Hospitality, Restaurants & Cafés",
    icon: "Utensils",
    desc: "Kitchen degreasing and front-of-house dining cleanliness.",
    body: [
      "In hospitality, cleanliness is the product. We provide nightly kitchen degreasing, dining-room detailing, washroom programs, and patio and entrance care for restaurants, cafés, hotels, and event venues.",
      "Seasonal deep cleans, hood-adjacent degreasing, and pre-inspection detailing keep health inspections stress-free.",
    ],
    services: ["commercial-cleaning", "deep-cleaning", "pressure-washing", "window-cleaning"],
  },
  {
    slug: "construction-development",
    name: "Construction & Development Sites",
    icon: "HardHat",
    desc: "Post-build clearance, detailing, and pre-occupancy inspection.",
    body: [
      "Builders hand over spaces — we make them handover-ready. Our construction-sector teams deliver rough cleans, final cleans, and sparkle cleans on schedules aligned to your trades and possession dates.",
      "From single custom homes to multi-unit developments, we scale crews to hit closing deadlines with photo-documented sign-offs.",
    ],
    services: ["post-construction-cleaning", "window-cleaning", "pressure-washing", "deep-cleaning"],
  },
];
